import { render, staticRenderFns } from "./extra-style-center.vue?vue&type=template&id=4f28b595&scoped=true&"
import script from "./extra-style-center.vue?vue&type=script&lang=js&"
export * from "./extra-style-center.vue?vue&type=script&lang=js&"
import style0 from "./extra-style-center.vue?vue&type=style&index=0&id=4f28b595&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f28b595",
  null
  
)

export default component.exports